import sendForm from './modules/sendForm'
import cookies from './modules/cookies'
import shareButton from './modules/shareButton'
import aos from './modules/aos'
import swiper from './modules/swiper'
import faq from './modules/faq'
import attachInput from './modules/attachInput'
import simulator from './modules/simulator'
import menu from './modules/menu'
import select from './modules/select'
import lottie from './modules/lottie'
import contactForm from './modules/contactForm'
import brandsDetail from './modules/brandsDetail'
import petSpace from './modules/petSpace'
import petSpaceForm from './modules/petSpaceForm'
import mask from './modules/mask'
import institutional from './modules/institutional'
import language from './modules/language'
import productsListFunctionalities from './modules/productsListFunctionalities'

sendForm()
cookies()
shareButton()
aos()
swiper()
faq()
attachInput()
simulator()
menu()
select()
lottie()
contactForm()
brandsDetail()
petSpace()
petSpaceForm()
mask()
institutional()
language()
productsListFunctionalities()
